import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "../../entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import { getAppId, getRootComponent } from "../../utilities/ElementUtils";
import { getUserProfileFromSession } from "../../services/CxpProfileService";
import axios from "axios";
import DataUtils from "../../utilities/DataUtils";
import ReCaptchaV3 from "../captcha/CaptchComponent";
import ReCaptchaButton from "../captcha/captcha-button";


interface Props {
  field: FormSectionElements;
  isEng: boolean;
  callback;
  returnIndex?: number;
  callbackValidate?: (errors: any) => void;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
}

interface State {


}
export class SubmitButtonComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

  }

  arrayToString=(_a)=> {
    if (Array.isArray(_a)) {
      return _a.join(' '); 
    } else {
      return [_a]
    }
  }


  handleSecureButtonClick = async (token: string) => {
    let field=this.props.field;
    let section = field.parent.parent;
    const userProfile = getUserProfileFromSession()

    // FormValidationUtils.runJavascript(this.props.field);

    field.Value = null;
    FormValidationUtils.resetSectionValidation(section);
    const invalidControlList = FormValidationUtils.invalidControls(section);
    if (invalidControlList.length > 0) {
        this.props.callbackValidate(invalidControlList);
        return;
    }    
    const api = field.Recaptcha?.api;
    const programContainer=field.parent.parent.parent;
    const entity = DataUtils.collectFormValue(programContainer);
    entity.language = this.props.isEng ? "EN" : "FR";
    entity.userId= userProfile?.userId
    entity.token = token;

    axios.post(api, entity)
      .then(response => {
        field.Value = response.data;
        field.Valid = true;

        if (this.props.field.StepperScript) {
          const customJSFunc = eval(`(${this.props.field.StepperScript})`);
          customJSFunc((index) => {
            let destination = index;
            if (this.props.returnIndex!=null) {
              destination = this.props.returnIndex;
              if (this.props.callbackStepIndex)
                this.props.callbackStepIndex(destination);
            } else {
              if (typeof destination === "string") {
                const root = getRootComponent(this.props.field);
                const foundSection = root.ListOfFormSections.find(section => section.ENUTitle == destination);
                const indexNum = root.ListOfFormSections.indexOf(foundSection);
                if (this.props.callbackStepIndex)
                this.props.callbackStepIndex(indexNum)
              } else {
                if (this.props.callbackStepIndex)
                this.props.callbackStepIndex(destination);
              }
            }
          }, response.data);
        }
        this.props.callback(field.parent.parent.parent);
      })
      .catch(error => {
        console.log("error");
        field.Valid = false;
        this.props.callback(field.parent.parent.parent);
      });
    
  }

  render() {
    let field = this.props.field;
    let controlArray = [];
    let title = this.props.isEng ? this.props.field.ENUTitle : this.props.field.FRATitle;

    if (field.InitScript && Utils.isNotNullOrEmpty(field.InitScript)) {
      const customJSFunc = eval(`(${field.InitScript})`);
      try {
        customJSFunc(field, process.env);
      } catch (ex) {
        console.log(ex);
      }

      if (field.Editable !== 'Y' || field.Visible == false) {
        return null;
      }
    }
    console.log("DISABLED_RECAPTCHA", process.env.DISABLED_RECAPTCHA)
    const lang = this.props.isEng ? 'en' : 'fr';
    const ClassName = "ontario-button " + this.arrayToString(this.props.field.ClassName);
    controlArray.push(
      <div style={{ textAlign: 'left' }} key={"button_" + field.parent.Sequence + "_" + field.Id}>
      {process.env.DISABLED_RECAPTCHA =='false' &&   
      <ReCaptchaV3 lang={this.props.isEng ? 'en' : 'fr'}>
          <ReCaptchaButton title={this.props.isEng ? field.ENUTitle : field.FRATitle} 
            id={`button_${field.parent.Sequence}_${field.Id}`}
            buttonHandler={this.handleSecureButtonClick} action={this.props.field.Recaptcha?.action}>
            <div dangerouslySetInnerHTML={{__html: field.Recaptcha?.content[lang]}}/>
          </ReCaptchaButton>
        </ReCaptchaV3>}
      </div>);

    return controlArray;
  }
}